import styled from 'styled-components';

export const LifenLink = styled.a`
  color: #ff6742;
`;
